// useMarkNotificationsRead hook - Mark notifications as read
// Feature: 015-we-want-to
// T026: Frontend hook for marking notifications as read

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api/client';

interface MarkAsReadResponse {
  message: string;
  marked_count: number;
}

export function useMarkNotificationsRead() {
  const queryClient = useQueryClient();

  return useMutation<MarkAsReadResponse, Error>({
    mutationFn: async () => {
      return apiClient.patch<MarkAsReadResponse>('/notifications/mark-read', {});
    },
    onSuccess: () => {
      // Invalidate notifications and unread count queries to trigger refetch
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
      queryClient.invalidateQueries({ queryKey: ['notifications', 'unread-count'] });
    },
  });
}
